/**
 * Multi-agent timeline constants.
 *
 * Colour map for activity-log entry tones — kept here so
 * any future timeline variant reads from the same palette.
 */

export type TimelineTone = "info" | "ok" | "warn" | "err";

export const TIMELINE_TONE_COLOR: Record<TimelineTone, string> = {
  info: "var(--ma-text-muted)",
  ok:   "var(--ma-state-ok)",
  warn: "var(--ma-state-warn)",
  err:  "var(--ma-state-err)",
};
